<div class="mb-3">
  <ng-template [ngTemplateOutlet]="saveBtnTmpl"></ng-template>
</div>
<div class="alert alert-secondary-warning2">
  <i class="far fa-exclamation-triangle alert-icon"></i>
  <div class="alert-content">
    <div class="text-bold text-dark" i18n>Specify Rental & Channel Account</div>
    <div i18n>
      The new booking.com listing will use information currently in your AdvanceCM account. The most important
      information is listing below for verification. Please update this information as needed prior to creating the
      listing.
    </div>
  </div>
</div>

<div class="d-flex flex-column gap-3">
  <div class="card">
    <div class="card-header">
      <h6 class="m-0" i18n>Information</h6>
    </div>
    <div class="card-body">
      <app-rental-select
        label="Autofill from the existing rental"
        i18n-label
        [multiple]="false"
        [ctrl]="rentalCtrl"
        [disabled]="rentalCtrl.disabled"
        (selectedItemsChange)="onRentalChange($event)"
        matTooltip="Selecting a property will fetch data from the rental and auto-fill the fields below. This does not link the property to a BDC listing"
        i18n-matTooltip
      ></app-rental-select>
      <div class="row" [formGroup]="form">
        <div class="col-md-6">
          <mat-form-field2>
            <input
              type="text"
              matInput
              formControlName="property_name"
              placeholder="Property Name"
              i18n-placeholder
              required
            />
            <mat-error *ngIf="form.get('property_name').touched && form.get('property_name').hasError('required')">
              <ng-container i18n>Property Name is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2>
            <mat-label i18n>Property Type</mat-label>
            <mat-select formControlName="property_category" required>
              <mat-option *ngFor="let propertyType of availablePropertyClassTypes" [value]="propertyType.code">
                {{ propertyType.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="form.get('property_category').touched && form.get('property_category').hasError('required')"
            >
              <ng-container i18n>Category is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2>
            <input
              type="number"
              matInput
              formControlName="room_count"
              placeholder="Room Count"
              i18n-placeholder
              required
            />
            <mat-error *ngIf="form.get('room_count').touched && form.get('room_count').hasError('required')">
              <ng-container i18n>Room Count is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2>
            <input type="number" matInput formControlName="floor_count" placeholder="Floor Count" i18n-placeholder />
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <mat-form-field2>
            <mat-label i18n>Stars</mat-label>
            <mat-select formControlName="stars">
              <mat-option [value]="item" *ngFor="let item of [0, 1, 2, 3, 4, 5]">{{ item }}</mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
        <div class="col-md-6">
          <app-currency-select [ctrl]="form.get('currency_code')" bindValue="code"></app-currency-select>
        </div>
        <div class="col-md-6">
          <app-language-select
            [items]="languages"
            [ctrl]="form.get('primary_language')"
            label="Primary Language"
            i18n-label
            matTooltip="Specifies the language in which the property wants their Booking.com extranet content and communication (emails, notifications, ...) etc"
            i18n-matTooltip
          ></app-language-select>
        </div>
        <div class="col-md-6">
          <app-language-select
            [items]="languages"
            [ctrl]="form.get('languages_spoken')"
            [multiple]="true"
            [showBlankItem]="false"
            label="Language Spoken"
            i18n-label
            matTooltip="The languages spoken by staff"
            i18n-matTooltip
          ></app-language-select>
        </div>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <h6 class="m-0">Check-in/Check-out Time</h6>
    </div>
    <div class="card-body">
      <div class="row">
        <ng-container [formGroup]="checkInForm">
          <div class="col-md-6">
            <mat-form-field2>
              <mat-label i18n>Check-in Time From</mat-label>
              <mat-select formControlName="from" required>
                <mat-option *ngFor="let time of timeOptions" [value]="time.value">
                  {{ time.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="checkInForm.get('from').touched && checkInForm.get('from').hasError('required')">
                <ng-container i18n>Check-in Time From is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-6">
            <mat-form-field2>
              <mat-label i18n>Check-in Time Until</mat-label>
              <mat-select formControlName="until">
                <mat-option *ngFor="let time of timeOptions" [value]="time.value">
                  {{ time.label }}
                </mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
        </ng-container>
        <ng-container [formGroup]="checkOutForm">
          <div class="col-md-6">
            <mat-form-field2>
              <mat-label i18n>Check-out Time From</mat-label>
              <mat-select formControlName="from">
                <mat-option *ngFor="let time of timeOptions" [value]="time.value">
                  {{ time.label }}
                </mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
          <div class="col-md-6">
            <mat-form-field2>
              <mat-label i18n>Check-out Time Until</mat-label>
              <mat-select formControlName="until">
                <mat-option *ngFor="let time of timeOptions" [value]="time.value">
                  {{ time.label }}
                </mat-option>
              </mat-select>
            </mat-form-field2>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <h6 class="mb-0 mr-3">Address</h6>
      <mat-checkbox
        [formControl]="physicalAddressForm.get('display_address')"
        matTooltip="Check to display your property address on Booking.com"
        i18n-matTooltip
      >
        Display Address
      </mat-checkbox>
    </div>
    <div class="card-body">
      <div class="row">
        <ng-container [formGroup]="physicalAddressForm">
          <div class="col-md-12">
            <mat-form-field2>
              <input
                type="text"
                matInput
                formControlName="address_line"
                placeholder="Address"
                i18n-placeholder
                required
                appGooglePlaces
                (onAddressChange)="onPlaceChange($event)"
                autocomplete="address-1"
              />
              <mat-error
                *ngIf="
                  physicalAddressForm.get('address_line').touched &&
                  physicalAddressForm.get('address_line').hasError('required')
                "
              >
                <ng-container i18n>Address is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-4">
            <mat-form-field2>
              <input type="text" matInput formControlName="city_name" placeholder="City" i18n-placeholder required />
              <mat-error
                *ngIf="
                  physicalAddressForm.get('city_name').touched &&
                  physicalAddressForm.get('city_name').hasError('required')
                "
              >
                <ng-container i18n>City is required</ng-container>
              </mat-error>
            </mat-form-field2>
          </div>
          <div class="col-md-4">
            <app-country-select
              placeholder="Country"
              [codeCtrl]="physicalAddressForm.get('country_code')"
            ></app-country-select>
          </div>
          <div class="col-md-4">
            <mat-form-field2>
              <mat-label i18n>Postal Code</mat-label>
              <input type="text" matInput formControlName="postal_code" placeholder="Postal Code" i18n-placeholder />
            </mat-form-field2>
          </div>
        </ng-container>
        <div class="col-md-12">
          <app-map-control [zoom]="14" [formControl]="gpsLocationControl" height="400px"></app-map-control>
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <h6 class="mb-0 mr-3">Translations</h6>
    </div>
    <div class="card-body bg-default2" [formGroup]="form">
      <div class="alert alert-secondary-warning2">
        <i class="far fa-exclamation-triangle alert-icon"></i>
        <div class="alert-content">
          <div i18n>Non-English translations of the physical address.</div>
        </div>
      </div>
      <div class="bg-white rounded border">
        <mat-accordion formArrayName="translations">
          <mat-expansion-panel
            *ngFor="let transForm of translationsFormArray.controls; let ci = index"
            [formGroupName]="ci"
            [expanded]="true"
          >
            <mat-expansion-panel-header>
              <mat-panel-title> Translation {{ ci + 1 }} </mat-panel-title>
              <mat-panel-description class="gap-3 text-normal-bold" (click)="$event.stopPropagation()">
                <div class="flex-fill"></div>
                <app-language-select
                  [items]="languages"
                  [ctrl]="transForm.get('language_code')"
                  [inline]="true"
                  [showBlankItem]="false"
                ></app-language-select>
                <button
                  class="btn btn-secondary-danger"
                  (click)="onDeleteTranslation(ci)"
                  matTooltip="Delete this translation"
                  i18n-matTooltip
                >
                  <i class="cs-icon cs-icon-trash"></i>
                </button>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field2>
                  <input
                    type="text"
                    matInput
                    formControlName="property_name"
                    placeholder="Property Name"
                    i18n-placeholder
                  />
                  <mat-error
                    *ngIf="
                      transForm.get('property_name').touched && transForm.get('property_name').hasError('required')
                    "
                  >
                    <ng-container i18n>Property Name is required</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-md-12">
                <mat-form-field2>
                  <input type="text" matInput formControlName="address_line" placeholder="Address" i18n-placeholder />
                  <mat-error
                    *ngIf="transForm.get('address_line').touched && transForm.get('address_line').hasError('required')"
                  >
                    <ng-container i18n>Address is required</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-md-4">
                <mat-form-field2>
                  <input
                    type="text"
                    matInput
                    formControlName="city_name"
                    placeholder="City"
                    i18n-placeholder
                    required
                  />
                  <mat-error
                    *ngIf="transForm.get('city_name').touched && transForm.get('city_name').hasError('required')"
                  >
                    <ng-container i18n>City is required</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <div class="mt-3">
        <button class="btn btn-secondary-info" (click)="onAddTranslation()" [disabled]="isEditDisabled === true">
          <i class="far fa-plus"></i>
          <ng-container i18n> Add Translation </ng-container>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="mt-3">
  <ng-template [ngTemplateOutlet]="saveBtnTmpl"></ng-template>
</div>

<ng-template #saveBtnTmpl>
  <div class="d-flex align-items-center justify-content-end">
    <button class="btn btn-secondary-info" [disabled]="isLoading || isEditDisabled === true" (click)="onSave(form)">
      <i class="cs-icon cs-icon-save" *ngIf="!isLoading"></i>
      <i class="far fa-spin fa-spinner" *ngIf="isLoading"></i>
      <ng-container i18n>Save</ng-container>
    </button>
  </div>
</ng-template>
